"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _component = require("../component");

var _Scroll = _interopRequireDefault(require("./Scroll"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(_default, _PureComponent);

  function _default(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.state = {
      left: props.scrollLeft || 0,
      top: props.scrollTop || 0
    };
    _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = _default.prototype;

  _proto.getRect = function getRect() {
    var left = this.props.scrollLeft === undefined ? this.state.left : this.props.scrollLeft;
    var top = this.props.scrollTop === undefined ? this.state.top : this.props.scrollTop;
    return {
      left: left,
      top: top
    };
  };

  _proto.handleScroll = function handleScroll(x, y) {
    var left = this.scrollX ? x : 0;
    var top = this.scrollY ? y : 0;
    this.setState({
      left: left,
      top: top
    });

    if (this.props.onScroll) {
      var _this$props;

      for (var _len = arguments.length, others = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        others[_key - 2] = arguments[_key];
      }

      (_this$props = this.props).onScroll.apply(_this$props, [left, top].concat(others));
    }
  };

  _proto.render = function render() {
    var _this$getRect = this.getRect(),
        left = _this$getRect.left,
        top = _this$getRect.top;

    return _react.default.createElement(_Scroll.default, _extends({}, this.props, {
      left: left,
      top: top,
      scrollX: this.scrollX,
      scrollY: this.scrollY,
      onScroll: this.handleScroll
    }));
  };

  _createClass(_default, [{
    key: "scrollX",
    get: function get() {
      var scroll = this.props.scroll;
      return scroll === 'x' || scroll === 'both';
    }
  }, {
    key: "scrollY",
    get: function get() {
      var scroll = this.props.scroll;
      return scroll === 'y' || scroll === 'both';
    }
  }]);

  return _default;
}(_component.PureComponent);

exports.default = _default;

_defineProperty(_default, "propTypes", {
  onScroll: _propTypes.default.func,
  scroll: _propTypes.default.oneOf(['x', 'y', 'both', '']),
  scrollLeft: _propTypes.default.number,
  scrollTop: _propTypes.default.number
});

_defineProperty(_default, "defaultProps", {
  scroll: 'both'
});